import { render, staticRenderFns } from "./Monedero.vue?vue&type=template&id=1ed8f384&scoped=true"
import script from "./Monedero.vue?vue&type=script&lang=js"
export * from "./Monedero.vue?vue&type=script&lang=js"
import style0 from "./Monedero.vue?vue&type=style&index=0&id=1ed8f384&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed8f384",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed8f384')) {
      api.createRecord('1ed8f384', component.options)
    } else {
      api.reload('1ed8f384', component.options)
    }
    module.hot.accept("./Monedero.vue?vue&type=template&id=1ed8f384&scoped=true", function () {
      api.rerender('1ed8f384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/monedero/Monedero.vue"
export default component.exports